import React, { useEffect, useState } from 'react';
// Navbar/Footer are rendered globally in App.js; page uses shared wrapper styles
import './RoboticsDashboard.css';

export default function RoboticsDashboard() {
  const [robots, setRobots] = useState([
    { robot_id: 'unit-001', state: 'IDLE', battery_v: 7.4 },
    { robot_id: 'unit-002', state: 'DOCKED', battery_v: 8.0 },
    { robot_id: 'unit-003', state: 'ACTIVE', battery_v: 7.9 },
  ]);

  useEffect(() => {
    // Placeholder for future real-time updates (WebSocket/polling)
  }, []);

  const handleAction = (robotId, action) => {
    alert(`${action} command sent to ${robotId}`);
  };

  return (
    <main className="aboutContainer">
      <h1>Robotics Control Center</h1>
      <p style={{ marginTop: 8, color: '#333', lineHeight: 1.6 }}>
        Monitor and manage connected ChronoTech robots in real time.
      </p>

      <section className="aboutText" style={{ marginTop: 18 }}>
        <div className="aboutBioCards">
          {robots.map((r) => (
            <div key={r.robot_id} className="bioCard" role="region" aria-label={`Robot ${r.robot_id}`}>
              <div className="bioInfo">
                <h3>{r.robot_id}</h3>
                <p>Battery: {r.battery_v.toFixed(1)} V</p>
                <p>Status: {r.state}</p>
                <div className="robotControls" aria-label="Robot controls">
                  <button onClick={() => handleAction(r.robot_id, 'Start')}>Start</button>
                  <button onClick={() => handleAction(r.robot_id, 'Dock')}>Dock</button>
                  <button onClick={() => handleAction(r.robot_id, 'Stop')}>Stop</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </main>
  );
}

